export default {
  singleMarketWeekendDeliveryTriggerSetUp: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.trigger.set_up',
    defaultMessage: 'Set up now',
  },
  singleMarketWeekendDeliveryTriggerUpdate: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.trigger.update',
    defaultMessage: 'Update weekend delivery',
  },
  singleMarketWeekendDeliveryDrawerHeadline: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.drawer.headline',
    defaultMessage: 'Manage weekend delivery',
  },
  singleMarketWeekendDeliveryDrawerInstruction: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.drawer.instruction',
    defaultMessage: 'Select shipping providers that deliver on weekends.',
  },
  singleMarketWeekendDeliveryConfigurationFormSubmitButton: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.configuration_form.submit_button',
    defaultMessage: 'Save changes',
  },
  singleMarketWeekendDeliveryConfigurationFormTableHeadline: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.configuration_form.table_headline',
    defaultMessage: 'Shipping provider',
  },
  singleMarketWeekendDeliveryConfigurationFormTableHeadSelectAll: {
    id: 'bo_seller.options.shipping.single_market_weekend_delivery.configuration_form.table_head_select_all',
    defaultMessage: 'Select all',
  },
}
